import React from 'react'
import FeaturesSection from '../UAEPageComponents/FeaturesSection'
import { OtherFeaturesDataRetail, UAERetailFeatures } from '../../../constants/common'
import HeaderSection from '../UAEPageComponents/HeaderSection'
import OtherFeatures from '../UAEPageComponents/OtherFeatures'
import OutletTypes from '../UAEPageComponents/OutletTypes'
import styles from '../../../styles/UAEPageComponents.module.css'
import NewFaqSection from '@/components/HomeLanding/HomeLandingComponents/NewFaqSection'
import BusinessUnlockSectionUAE from '@/components/HomeLanding/HomeLandingComponents/BusinessUnlockSectionUAE'
import ConnectWithUsUAE from '@/components/HomeLanding/HomeLandingComponents/ConnectWithUsUAE'
import TestimonialSectionUAE from '@/components/HomeLanding/HomeLandingComponents/TestimonialSectionUAE'
import AwardsSection from '@/components/HomeLanding/HomeLandingComponents/AwardsSection'
import ContactSection from '../UAEPageComponents/ContactSection'
import BlogsAndVideos from '@/components/HomeLanding/HomeLandingComponents/BlogsAndVideos'
import UAEBlogsSection from '@/components/HomeLanding/HomeLandingComponents/UAEBlogsSection'
import ContqactSection from '../UAEPageComponents/ContactSection'
import { QbExperience } from '@/components/qbStrap'

const DektopRetailPage = () => {
  const UAERetailHeader = {
    firstTitle: "POS Billing Software for",
    secondTitle: "Retail Stores",
    description: "From high-street retail stores to bustling supermarkets and convenience shops, UAE’s retail ecosystem runs on speed, accuracy, and operational efficiency. QueueBuster’s Retail POS Billing Software is built to simplify everything, quick billing, real-time inventory tracking, supplier management, online order sync, and full VAT compliance.",
    images: {
      bgVector: "/assets/UAERetailPage/bgVector.svg",
      bgwidth: "47rem",
      bgheight: "45rem",
      bgtop: "5%",
      bgleft: "14%",
      bgbottom: "10%",
      bgright: "10%",
      bgzindex: "0",
      mainImage: {
        src: "/assets/UAERetailPage/smiley-woman-wearing-glasses-with-tag-holding-shopping-bag.webp",
        alt: "QueueBuster for Retail",
        width: "43rem",
        height: "50rem",
        bottom: "0",
        right: "0"
      },
      img1: {
        src: "/assets/UAERetailPage/quickBill.svg",
        alt: "Quick Bill",
        width: "18rem",
        height: "19rem",
        bottom: "20rem",
        left: "10%"

      },
      img2: {
        src: "/assets/UAERetailPage/Schedule.svg",
        alt: "Schedule",
        width: "15rem",
        height: "5.5rem",
        top: "10%",
        left: "28%",
      },
      img3: {
        src: "/assets/UAERetailPage/planeImg.svg",
        alt: "Plane Image",
        width: "18rem",
        height: "11.5rem",
        top: "15%",
        right: "0rem"
      },

      strVector1: {
        src: "/assets/UAERetailPage/Vector.svg",
        alt: "Vector 1",
        width: "2rem",
        height: "2rem",
        top: "18.5%",
        left: "30%"
      },
      strVector2: {
        src: "/assets/UAERetailPage/Vector1.svg",
        alt: "Vector 2",
        width: "2rem",
        height: "2rem",
        top: "4%",
        right: "30%"
      },
      strVector3: {
        src: "/assets/UAERetailPage/Vector2.svg",
        alt: "Vector 3",
        width: "2rem",
        height: "2rem",
        bottom: "25%",
        right: "-3%"
      },

    }
  }
  
  const OutletTypesData = [
    {
      image: "/assets/UAERetailPage/OutletTypesImg1.png",
      title: "Fashion & Apparel",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg2.png",
      title: "Footwear",
      hoverColor: "#225590"
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg8.png",
      title: "Cosmetics",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg3.png",
      title: "Accessories",
      hoverColor: "#225590"
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg4.png",
      title: "Home & Living",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg5.png",
      title: "Carts & Kiosks",
      hoverColor: "#225590"
    },
    {
      image: "/assets/UAERetailPage/Restaurants.png",
      title: "Restaurants",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg7.png",
      title: "Pet Store",
      hoverColor: "#225590"
    },

  ]

  const faqs = [
    {
      para: (
        <span style={{ width: "90%" }}>
          Why is QueueBuster POS ideal for UAE retail stores?
        </span>
      ),
      des: "Because it’s VAT & ZATCA compliant, supports multiple outlets, and simplifies billing, stock, and customer engagement.",
      id: 1,
      activeIndex: 1,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Can it handle multiple locations?
        </span>
      ),
      des: "Yes. You can sync inventory and sales across stores, warehouses, and even franchises.",
      id: 2,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Is it suitable for supermarkets and small shops alike?
        </span>
      ),
      des: "Absolutely. QueueBuster scales with your business, from single shops to large chains.",
      id: 3,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Does it support Arabic language invoices?
        </span>
      ),
      des: "Yes. You can generate bilingual invoices (English & Arabic).",
      id: 4,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Can it integrate with my ERP and CRM?
        </span>
      ),
      des: "Yes. QueueBuster supports seamless integration with major ERP/CRM systems used in UAE retail.",
      id: 5,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          How does it help with VAT compliance?
        </span>
      ),
      des: "By generating VAT-compliant invoices, detailed tax reports, and automated filing support.",
      id: 6,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Is there a mobile app for UAE retailers?
        </span>
      ),
      des: <>Yes. QueueBuster’s mobile app lets you check sales, approve discounts, and monitor inventory on the go.</>,
      id: 7,
      activeIndex: 0,
    },

  ]

  return (
    <div style={{ fontFamily: 'GilroyMedium' }}>
      <HeaderSection data={UAERetailHeader} />

      <FeaturesSection
        data={UAERetailFeatures}
        title={"Features That Fit Your Business"} />

      <OtherFeatures
        data={OtherFeaturesDataRetail}
        title={<>Other Important Features for <br /> Retail Billing Software</>} />

      <OutletTypes title={"Retail Outlet Types"} data={OutletTypesData} />
      {/* <div ><TestimonialSectionUAE /></div> */}
      <div className={styles.resposiveSections}>
        <QbExperience
          videoSrc="https://www.youtube.com/embed/7kLTye6Nvfk?si=-YFUVmQCxamDv8U6"
          header="Quick Walkthrough"
          title="Watch First, Decide Later!"
          description="From single stores to multi-outlet chains, QueueBuster is changing how retail businesses operate across the UAE. Watch the video to see exactly how."
        />
        <AwardsSection /> 
      <div ><BusinessUnlockSectionUAE /></div>
      <div><ConnectWithUsUAE /></div>
      </div>
      <div>  <NewFaqSection FaqTableData={faqs} heading={"FAQs for UAE Retail POS Software"}/>  </div>

      <div>
        <ContqactSection 
        title="Couldn’t Find What You Wanted?"
        description= {<>Worry not, just send us your inquiry and <br />wait while our Retail POS experts contact you.</>}
        buttonText="Request a callback"
      />
      </div>

      <div >
        <UAEBlogsSection />
      </div>
    </div>
  )
}

export default DektopRetailPage